<template>
  <div class="flex flex-col items-center justify-center px-4">
    <p class="font-semibold text-lg text-BLACK pt-5">Select Language</p>
    <div class="rounded-lg bg-WHITE flex flex-row p-3 gap-3 items-center w-full mt-8">
      <font-awesome-icon class="black-icon" icon="fa-solid fa-magnifying-glass" />
      <input
        v-model="message"
        placeholder="Search Language"
        class="placeholder-[##8B8B8B] bg-WHITE border-0 focus:outline-none text-sm text-BLACK w-full"
      />
    </div>
    <div class="flex flex-col gap-3 w-full pt-6">
      <language-item
        v-for="(language, index) in languages"
        :selected="language.selected"
        :language="language"
        @update:selected="selectLanguage(index)"
      ></language-item>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import LanguageItem from '../LanguageItem.vue'
import { useGameStore } from '@/stores/game'

const gameStore = useGameStore()

const massage = ref('')

const languages = ref([
  {
    name: 'English',
    icon: 'flag-united-kingdom.svg',
    selected: gameStore.language === 'en',
    code: 'en'
  },
  {
    name: 'Germany',
    icon: 'flag-germany.svg',
    selected: gameStore.language === 'de',
    code: 'de'
  },
  {
    name: 'Türkçe',
    icon: 'flag-turkey.svg',
    selected: gameStore.language === 'tr',
    code: 'tr'
  }
])
console.log(gameStore.language)
const selectLanguage = (index) => {
  gameStore.language = languages.value[index].code
  languages.value.forEach((language, i) => {
    language.selected = i === index
  })
}
</script>
